
define('ldsh!modules/invoice_status/list/row', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '  \n  <td>\n   <span name="name"></span>\n  </td>\n\n  <td>\n   \t\t<a href="javascript:;" class="edit-item">Edit</a>\n  </td>\n  <td>\n   \t\t<a href="javascript:;" class="delete-item">Delete</a>\n  </td>\n';

}
return __p
};});

